<template>
  <div class="home">
    <PageHeader></PageHeader>
    <HomeHeader></HomeHeader>
    <!-- min-height用于防止切换时页面闪烁（footer跑上来） -->
    <div style="min-height: 600px">
      <router-view :key="$route.fullPath" style="padding-bottom: 35px" />
    </div>
    <RightSideBar></RightSideBar>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import HomeHeader from "@/components/layout/HomeHeader";
import PageHeader from "@/components/layout/PageHeader";
import PageFooter from "@/components/layout/PageFooter";
import RightSideBar from "@/components/layout/RightSideBar";

export default {
  name: "Home",
  components: {
    PageHeader,
    HomeHeader,
    PageFooter,
    RightSideBar,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {

  },
};
</script>


<style scoped lang="scss">
.home {
  background-color: #f1f1f1;
  // background-color: #fff;
}

</style>

